module.exports = __webpack_public_path__ + "static/training-3a4a7f574bfeb14cdb07ba5cd0f3dbfd.jpeg";